export default {
  componentName: 'SearchFilters',
  fr: {
    withWithoutFees: 'Avec et sans frais',
    withoutFees: 'Sans frais uniquement',
    label: 'Frais',
    placeholder: 'Toutes',
    ariaLabel:
      'Filtrer par type de frais. Liste déroulante réduite, {1} sur {2}. Option {0} sélectionnée. Pour changer la sélection, appuyez sur entrer, puis utilisez flèche haut et bas. Appuyez sur entrer pour confirmer la sélection.',
    optionsDescription: 'Liste déroulante de 2 options, ouverte.',
    optionsDescriptionMobile: 'Combobox of 2 options, open.',
    ariaLabelItemSelected: '{0}. Sélectionné. Option {1} sur {2}',
    ariaLabelItemUnselected: '{0}. Non sélectionné. Option {1} sur {2}'
  },
  en: {
    withWithoutFees: 'Fees and no fees',
    withoutFees: 'No fees only',
    label: 'Fees',
    placeholder: 'All',
    ariaLabel:
      'Filter by fee type. Combobox closed, {1} of {2}. Option {0} selected. To change the selection, use up and down key. Press enter to confirm the selection.',
    optionsDescription: 'Combobox of 2 options, open.',
    optionsDescriptionMobile: 'Combobox of 2 options, open.',
    ariaLabelItemSelected: '{0}. Selected. Option {1} of {2}',
    ariaLabelItemUnselected: '{0}. Not selected. Option {1} of {2}'
  }
}
